import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
  timeout: 15000,
});

export async function createSignup({ firstName, email, source }) {
  const { data } = await api.post("/signups", {
    first_name: firstName,
    email,
    source,
  });
  return data;
}

export async function getSignupsCount() {
  const { data } = await api.get("/signups/count");
  return data;
}

export async function listSignups(adminKey, limit = 500) {
  const { data } = await api.get("/signups", {
    params: { admin_key: adminKey, limit },
  });
  return data;
}
